import { Dialog, DialogPanel, Transition, TransitionChild } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import logo from "./assets/m2_gas_logo_white.png";
import { useState, useEffect, Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import { NavLinks } from "./constants";
export const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (href) => {
    return location.pathname === href;
  };

  return (
    <header className="absolute inset-x-0 top-0 z-50">
      <nav 
        className={`fixed top-0 left-0 z-50 text-[#2DA8FF] bg-[#333333] flex items-center justify-between h-20 w-full px-6 md:px-20 lg:px-32 transition-all duration-300 ${
          scrolled ? 'shadow-lg shadow-black/20' : ''
        }`}
      >
        <div className="flex lg:flex-1">
          <Link 
            to="/" 
            className="-m-1.5 p-1.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2DA8FF] focus:ring-offset-2 focus:ring-offset-[#333333] transition-transform duration-200 hover:scale-105"
          >
            <span className="sr-only">M2 Gas Services</span>
            <img alt="M2 Gas Services Logo" src={logo} className="h-12 w-auto" />
          </Link>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-[#2DA8FF] focus:outline-none focus:ring-2 focus:ring-[#2DA8FF] hover:bg-white/5 transition-colors duration-200"
            aria-label="Open main menu"
          >
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          {NavLinks.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`text-base font-semibold transition-all duration-200 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2DA8FF] focus:ring-offset-2 focus:ring-offset-[#333333] ${
                isActive(item.href)
                  ? "text-white bg-white/10"
                  : "text-[#2DA8FF] hover:text-white hover:bg-white/5"
              }`}
            >
              {item.name}
            </Link>
          ))}
        </div>
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <Link
            to="/request-appointment"
            className={`font-semibold px-7 py-3 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#333333] hover:shadow-lg hover:shadow-[#2DA8FF]/30 hover:-translate-y-0.5 ${
              isActive("/request-appointment")
                ? "bg-white text-[#333333]"
                : "text-black bg-[#2DA8FF] hover:text-white"
            }`}
          >
            {/* temp comment */}
            {/* Request Appointment */}
          </Link>
        </div>
      </nav>
      <Transition show={mobileMenuOpen} as={Fragment}>
        <Dialog onClose={setMobileMenuOpen} className="lg:hidden">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm" />
          </TransitionChild>
          <TransitionChild
            as={Fragment}
            enter="transform transition ease-out duration-300"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="transform transition ease-in duration-200"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-[#262626] p-6 sm:max-w-sm sm:ring-1 sm:ring-white/10">
              <div className="flex items-center justify-between">
                <Link 
                  to="/" 
                  className="-m-1.5 p-1.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2DA8FF]"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <span className="sr-only">M2 Gas Services</span>
                  <img alt="M2 Gas Services Logo" src={logo} className="h-8 w-auto" />
                </Link>
                <button
                  type="button"
                  onClick={() => setMobileMenuOpen(false)}
                  className="-m-2.5 rounded-md p-2.5 text-gray-200 focus:outline-none focus:ring-2 focus:ring-[#2DA8FF] hover:bg-white/5 transition-colors duration-200"
                  aria-label="Close menu"
                >
                  <XMarkIcon aria-hidden="true" className="size-6" />
                </button>
              </div>
              <div className="mt-6 flow-root">
                <div className="-my-6 divide-y divide-white/10">
                  <div className="space-y-2 py-6">
                    {NavLinks.map((item) => (
                      <Link
                        key={item.name}
                        to={item.href}
                        onClick={() => setMobileMenuOpen(false)}
                        className={`-mx-3 block rounded-lg px-3 py-3 text-base/7 font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#2DA8FF] ${
                          isActive(item.href)
                            ? "text-white bg-white/10"
                            : "text-[#2DA8FF] hover:bg-white/5"
                        }`}
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                  <div className="py-6">
                    <Link
                      to="/request-appointment"
                      onClick={() => setMobileMenuOpen(false)}
                      className={`-mx-3 block rounded-lg px-3 py-3 text-base/7 font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#2DA8FF] ${
                        isActive("/request-appointment")
                          ? "text-white bg-white/10"
                          : "text-[#2DA8FF] hover:bg-white/5"
                      }`}
                    >
                      {/* temp comment */}
                      {/* Request Appointment */}
                    </Link>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </Dialog>
      </Transition>
    </header>
  );
};

export default Navbar;